"use strict";

module.exports = function () {
  return JSON.stringify(this.customQueries);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/computed/custom-q.js
// module id = 9Urd
// module chunks = 58